// extracted by mini-css-extract-plugin
module.exports = {"elementsPosition":"ManagementPageHeader_elementsPosition__3uoHs"};